<template>
  <div>
    <modal
      name="savedModal"
      :draggable="!isMobile"
      :clickToClose="false"
      height="auto"
      :width="450"
    >
      <v-card style="height: 225px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Changes Saved</v-toolbar-title>
        </v-toolbar>
        <br />

        <v-card-subtitle
          >Agency name/address changes have been saved. The agency history will
          now be reloaded.</v-card-subtitle
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#00558C"
            dark
            @click="
              $modal.hide('savedModal');
              Search();
            "
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <div class="historyDiv">
      <v-layout justify-center align-content-center align-center>
        <v-flex xs12 sm12 md9 xl6>
          <v-row>
            <v-layout align-center align-content-center justify-center>
              <!-- <v-col cols="1" v-if="$vuetify.breakpoint.mdAndUp"> -->
              <v-col
                cols="1"
                v-if="$vuetify.breakpoint.smAndUp"
                style="padding: 10px !important"
              >
                <v-icon color="green" size="100">mdi-history</v-icon>
              </v-col>

              <v-col
                :cols="$vuetify.breakpoint.mdAndUp ? '8' : '11'"
                style="padding: 10px !important"
              >
                <h2 class="historyTitle">Agency Office Updates History</h2>
                <v-card-subtitle class="subtitle margin-left-15">
                  Use the down arrow on the right of the table to view the
                  agency's previous information.
                  <br />Records in
                  <span style="color: green">green</span>
                  indicate previously un-viewed changes from the last three
                  days.
                </v-card-subtitle>
                <br /><br /><br />
                <v-layout align-center align-content-center justify-center row>
                  <span v-if="dateProblem" style="color: red"
                    >Please adjust the From and To dates.</span
                  >
                  <br v-if="!dateProblem" />
                </v-layout>
              </v-col>
            </v-layout>
          </v-row>
        </v-flex>
      </v-layout>

      <v-row>
        <v-layout align-center align-content-center justify-center row>
          <!-- <v-col cols="1">
            <v-icon color="green" size="100">mdi-history</v-icon>
          </v-col>-->
          <v-col cols="1"></v-col>
          <v-col :cols="$vuetify.breakpoint.mdAndUp ? '2' : '5'">
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dateFormatted"
                  label="Date Range From"
                  hint="MM/DD/YYYY"
                  persistent-hint
                  readonly
                  @blur="date = parseDate(dateFormatted)"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                no-title
                @input="menu1 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col :cols="$vuetify.breakpoint.mdAndUp ? '2' : '5'">
            <v-menu
              ref="menu2"
              v-model="menu2"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dateFormatted2"
                  label="Date Range To"
                  hint="MM/DD/YYYY"
                  persistent-hint
                  readonly
                  @blur="date2 = parseDate(dateFormatted2)"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date2"
                no-title
                @input="menu2 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="2" v-if="$vuetify.breakpoint.mdAndUp">
            <v-btn color="green" class="menuBtn" dark @click="Search"
              >Update Results</v-btn
            >
          </v-col>
          <br /><br />
        </v-layout>
      </v-row>
      <v-row v-if="$vuetify.breakpoint.smAndDown">
        <v-col cols="3"></v-col>
        <v-col cols="6">
          <v-btn color="green" class="menuBtn" dark @click="Search"
            >Update Results</v-btn
          >
        </v-col>
        <v-col cols="3"></v-col>
      </v-row>
      <v-row align="center" align-content="center" justify="center">
        <v-flex xs11 md12 style="padding-left: 20px; padding-right: 20px">
          <br />
          <!-- <v-data-table
            v-model="selected"
            :headers="headers"
            :items="toApproves"
            :expanded.sync="expanded"
            item-key="name"
            show-select
            show-expand
            class="elevation-1"
          >-->
          <v-progress-circular
            indeterminate
            color="green"
            v-if="waitCircle"
            size="50"
            class="waitCircleHistory"
          ></v-progress-circular>
          <v-data-table
            id="historyTable"
            v-model="selected"
            :headers="headers"
            light
            dense
            :items="waitCircle ? [] : filteredAgencies"
            :no-data-text="
              waitCircle ? 'Please wait...' : 'No modifications found'
            "
            :expanded.sync="expanded"
            item-key="code"
            show-expand
            single-expand
            class="elevation-1"
          >
            <template v-slot:item.AOAgentNumPrimary="{ item }">
              <span :style="isNew(item) ? 'color:green' : ''">{{
                item.AOAgentNumPrimary
              }}</span>
            </template>

            <template v-slot:item.name="{ item }">
              <span :style="isNew(item) ? 'color:green' : ''">{{
                item.name
              }}</span>
            </template>

            <template v-slot:item.code="{ item }">
              <span :style="isNew(item) ? 'color:green' : ''">{{
                item.code
              }}</span>
            </template>

            <template v-slot:item.address1="{ item }">
              <span :style="isNew(item) ? 'color:green' : ''">{{
                item.address1
              }}</span>
            </template>

            <template v-slot:item.address2="{ item }">
              <span :style="isNew(item) ? 'color:green' : ''">{{
                item.address2
              }}</span>
            </template>

            <template v-slot:item.city="{ item }">
              <span :style="isNew(item) ? 'color:green' : ''">{{
                item.city
              }}</span>
            </template>
            <template v-slot:item.state="{ item }">
              <span :style="isNew(item) ? 'color:green' : ''">{{
                item.state
              }}</span>
            </template>

            <template v-slot:item.zip="{ item }">
              <span :style="isNew(item) ? 'color:green' : ''">{{
                item.zip
              }}</span>
            </template>

            <template v-slot:item.country="{ item }">
              <span :style="isNew(item) ? 'color:green' : ''">{{
                item.country
              }}</span>
            </template>
            <template v-slot:item.phone="{ item }">
              <span :style="isNew(item) ? 'color:green' : ''">{{
                item.phone | phone
              }}</span>
            </template>

            <template v-slot:item.phoneExt="{ item }">
              <span :style="isNew(item) ? 'color:green' : ''">{{
                item.phoneExt
              }}</span>
            </template>

            <template v-slot:item.lastModifiedBy="{ item }">
              <span :style="isNew(item) ? 'color:green' : ''">{{
                item.lastModifiedBy
              }}</span>
            </template>

            <template v-slot:item.lastModified="{ item }">
              <span :style="isNew(item) ? 'color:green' : ''">{{
                item.lastModified | dateTime
              }}</span>
            </template>

            <template v-slot:item.email="{ item }">
              <span
                v-if="splitEmail(item.email)"
                :style="isNew(item) ? 'color:green' : ''"
              >
                {{ item.email.split("@")[0] }}@
                <br />
                {{ item.email.split("@")[1] }}
              </span>
              <span v-else :style="isNew(item) ? 'color:green' : ''">{{
                item.email
              }}</span>
            </template>

            <template v-slot:item.data-table-expand="{ expand, isExpanded }">
              <v-tooltip top v-if="!isExpanded" color="green">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" @click="expand(!isExpanded)"
                    >mdi-chevron-down</v-icon
                  >
                </template>
                <span>Expand History</span>
              </v-tooltip>
              <v-tooltip top v-else color="green">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" @click="expand(!isExpanded)"
                    >mdi-chevron-up</v-icon
                  >
                </template>
                <span>Collapse History</span>
              </v-tooltip>
            </template>

            <!-- <template v-slot:item.data-table-select="{ isSelected, select}">
              <v-simple-checkbox color="green" :value="isSelected" @input="select($event)"></v-simple-checkbox>
            </template>-->

            <template v-slot:item.edit="{ item }">
              <v-tooltip top color="green" dark>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    :color="isNew(item) ? 'green' : '#00558c'"
                    @click="
                      editItem = item;
                      editDialog = true;
                    "
                    >mdi-lead-pencil</v-icon
                  >
                </template>
                <span>Edit</span>
              </v-tooltip>
            </template>
            <template
              v-slot:expanded-item="{ item, headers }"
              style="min-width: 100%"
            >
              <template v-if="$vuetify.breakpoint.smAndDown">
                <v-data-table
                  id="expansionHistoryTable"
                  :headers="headers"
                  :items="waitCircle ? [] : originals"
                  :no-data-text="
                    waitCircle ? 'Please wait...' : 'No history found'
                  "
                  class="elevation-1"
                  dark
                  :color="isNew(item) ? 'green' : '#00558c'"
                  style="
                    background-color: #00558c !important;
                    color: white !important;
                  "
                  item-key="code + lastModified"
                ></v-data-table>
              </template>
              <template
                v-else-if="
                  !itemHasOriginals(item) && $vuetify.breakpoint.mdAndUp
                "
              >
                <td colspan="16" style="text-align: center">
                  No history found.
                </td>
              </template>

              <template v-else>
                <td colspan="16" class="expanded">
                  <table
                    style="
                      border: 1px solid #00558c;
                      margin-top: 10px;
                      margin-bottom: 10px;
                      border-spacing: 0px;
                    "
                  >
                    <thead style="background-color: #00558c !important">
                      <tr
                        style="
                          background-color: #00558c !important;

                          border-collapse: collapse;
                          border-spacing: 0px;
                        "
                      >
                        <template v-for="header of headers">
                          <th
                            style="
                              background-color: #00558c !important;

                              border-collapse: collapse;
                              color: white !important;
                              border-spacing: 0px;
                            "
                            v-if="header.text != 'Edit'"
                            :key="header.value"
                          >
                            <span v-if="header.text != ''">
                              <strong>{{ header.text }}</strong>
                            </span>

                            <span v-else style="margin-left: 15px">{{
                              blankFill
                            }}</span>
                          </th>
                        </template>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="(original, index) of originals">
                        <tr v-if="original.code == item.code" :key="index">
                          <template v-for="header of headers">
                            <td
                              v-if="header.text != 'Edit'"
                              :key="original.code + '_' + header.value"
                              style="color: #00558c"
                            >
                              <span
                                v-if="
                                  header.text != 'Modified' &&
                                  header.text != 'Email' &&
                                  header.text != 'Phone' &&
                                  header.text != 'Primary Agency'
                                "
                              >
                                {{
                                  !original[header.value] ||
                                  original[header.value] == ""
                                    ? blankFill
                                    : original[header.value]
                                }}
                              </span>
                              <span v-else-if="header.text == 'Primary Agency'">
                                {{ original[header.value] }}
                              </span>

                              <span v-else-if="header.text == 'Email'">
                                <span v-if="splitEmail(original[header.value])">
                                  {{ original[header.value].split("@")[0] }}@
                                  <br />
                                  {{ original[header.value].split("@")[1] }}
                                </span>
                                <span v-else>{{ original[header.value] }}</span>
                              </span>
                              <span v-else-if="header.text == 'Phone'">{{
                                original[header.value] | phone
                              }}</span>
                              <span v-else>{{
                                original[header.value] | dateTime
                              }}</span>
                            </td>
                          </template>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </td>
              </template>
            </template>
          </v-data-table>
          <br />
          <br />
          <v-layout justify-end align-content-end align-end>
            <v-btn color="green" class="menuBtn" dark @click="$router.push('/')"
              >Return to Main Menu</v-btn
            >
            <!-- <v-btn color="green" class="menuBtn" dark style="margin-left:20px;">Approve Selected</v-btn> -->
          </v-layout>
        </v-flex>
      </v-row>
    </div>

    <br /><br /><br />
    <span v-if="editDialog">
      <v-dialog v-model="editDialog" max-width="700" style="z-index: '999'">
        <AgencyAddress
          :id="editItem.id"
          :agencyName="editItem.name"
          :aoName="editItem.AOName"
          :address="editItem.address1"
          :address2="editItem.address2"
          :city="editItem.city"
          :state="editItem.state"
          :zip="editItem.zip"
          :country="editItem.country"
          :phone="editItem.phone"
          :phoneExt="editItem.phoneExt"
          :email="editItem.email"
          :code="editItem.code"
          :companyId="editItem.companyId"
          :countryCode="editItem.countryCode"
          :phoneTypeId="editItem.phoneTypeId"
          :aoId="editItem.AOAgentNumPrimary"
          :addressTypeId="editItem.addressTypeId"
          :countryId="editItem.countryId"
          :primaryAgencyInd="editItem.primaryAgencyInd"
        />
      </v-dialog>
    </span>
  </div>
</template>
<script>
import AgencyAddress from "@/components/agency-address.vue";
import EventBus from "@/eventBus.js";
import API, { graphqlOperation } from "@aws-amplify/api";
import * as queries from "@/graphql/queries";
import utilityMixins from "@/utility-mixins.js";
import { HTTP } from "@/http-common.js";

var aWeekAgo = new Date();
aWeekAgo.setHours(aWeekAgo.getHours() - 7 * 24);

var threeDaysAgo = new Date();
threeDaysAgo.setHours(threeDaysAgo.getHours() - 2 * 24);

export default {
  components: {
    AgencyAddress,
  },
  mixins: [utilityMixins],
  created() {
    this.filterDate = new Date(threeDaysAgo);
    this.filterDate.setHours(0, 0, 0, 0);
    this.filterDate2 = new Date();
    this.filterDate2.setHours(0, 0, 0, 0);
    this.filterDate2 = new Date(
      this.filterDate2.setHours(this.filterDate2.getHours() + 1 * 24)
    );

    this.getAgencyUpdates();
  },
  methods: {
    isNew(item) {
      if (
        this.$store.state.agencyChanges.find((ac) => ac.AgencyId == item.code)
      )
        return true;

      return false;
    },
    splitEmail(email) {
      if (email.indexOf("@") > 0) return true;

      return false;
    },
    itemHasOriginals(item) {
      let origItems = this.originals.filter((o) => o.code == item.code);
      return origItems && origItems.length > 0;
    },
    updateViewed() {
      HTTP.post(
        "views",
        {
          company: this.$store.state.currentCompany,
          userId: this.$store.state.currentUser.agentNum,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      ).catch((e) => {
        this.addToErrorLogs("History updateViewed post views", e);
      });
    },
    async getAgencyUpdates() {
      let today = new Date();
      today.setHours(23, 59, 59, 0);
      let threeDaysAgo = new Date();
      threeDaysAgo.setHours(threeDaysAgo.getHours() - 2 * 24);
      threeDaysAgo.setHours(0, 0, 0, 0);

      this.waitCircle = true;

      this.AOs = await API.graphql(
        graphqlOperation(queries.getAOs, {
          company: this.$store.state.currentCompany,
        })
      ).catch((e) => {
        this.waitCircle = false;
        this.addToErrorLogs("History getAOs", e);
        this.$modal.show("errorModal");
        return;
      });

      let offices = await API.graphql(
        graphqlOperation(queries.getAgencyHistoryByDateRange, {
          rangeStart: threeDaysAgo.toISOString(),
          rangeEnd: today.toISOString(),
          company: this.$store.state.currentCompany,
        })
      ).catch((e) => {
        this.addToErrorLogs(
          "History.vue getAgencyUpdates getAgencyHistoryByDateRange",
          e
        );
        this.waitCircle = false;
        this.$modal.show("errorModal");
        this.agencies = [];
        return;
      });

      if (!offices.data) {
        this.addToErrorLogs(
          "History.vue getAgencyUpdates getAgencyHistoryByDateRange",
          "No data returned."
        );
        this.waitCircle = false;
        this.$modal.show("errorModal");
        this.agencies = [];

        return;
      }

      this.agencies = [];

      for (let office of offices.data.getAgencyHistoryByDateRange) {
        let aoName;

        let AO = this.AOs.data.getAOs.find(
          (a) => a.AgentNumPrimary == office.AOAgentNumPrimary
        );

        if (AO) {
          aoName = (
            (AO.FirstName + " " + AO.MiddleName).trim() +
            " " +
            AO.LastName
          ).trim();
        }

        let agency = {
          AOAgentNumPrimary: office.AOAgentNumPrimary,
          AOName: aoName,
          code: office.AgencyCode,
          name: office.AgencyName,
          address1: office.AddressLine1,
          address2: office.AddressLine2,
          city: office.City,
          state: office.StateProvinceCode,
          zip: office.PostalCode,
          phone:
            (office.AreaCode ? office.AreaCode : "") +
            (office.PhoneNum ? office.PhoneNum : ""),
          phoneExt: office.PhoneExtensionNum,
          country: office.CountryName,
          email: office.Email,
          companyId: office.GLCompanyID,
          countryCode: office.ISOCountryCode,
          phoneTypeId: office.GLPhoneTypeID,
          addressTypeId: office.GLAddressTypeID,
          countryId: office.GLCountryID,
          lastModified: office.LastModified,
          lastModifiedBy: office.LastModifiedBy,
          id: office.EntAgencyID,
          primaryAgencyInd: office.PrimaryAgencyInd,
        };

        if (agency.phone == "0") {
          agency.phone = "";
        }

        this.agencies.push(agency);

        let officeHistory = await API.graphql(
          graphqlOperation(queries.getAgencyHistoryByAgencyCode, {
            agencyCode: office.AgencyCode,
            company: this.$store.state.currentCompany,
          })
        ).catch((e) => {
          this.addToErrorLogs(
            "History.vue getAgencyUpdates getAgencyHistoryByAgencyCode",
            e
          );
          this.waitCircle = false;
          this.$modal.show("errorModal");
          this.agencies = [];
          return;
        });

        if (!officeHistory.data) {
          this.addToErrorLogs(
            "History.vue getAgencyUpdates getAgencyHistoryByAgencyCode",
            "Data not returned."
          );
          this.waitCircle = false;
          this.$modal.show("errorModal");
          this.agencies = [];
          return;
        }

        if (officeHistory.data.getAgencyHistoryByAgencyCode) {
          for (let office of officeHistory.data.getAgencyHistoryByAgencyCode) {
            let agency = {
              AOAgentNumPrimary: office.AOAgentNumPrimary,
              code: office.AgencyCode,
              name: office.AgencyName,
              address1: office.AddressLine1,
              address2: office.AddressLine2,
              city: office.City,
              state: office.StateProvinceCode,
              zip: office.PostalCode,
              phone:
                (office.AreaCode ? office.AreaCode : "") +
                (office.PhoneNum ? office.PhoneNum : ""),
              phoneExt: office.PhoneExtensionNum,
              country: office.CountryName,
              email: office.Email,
              companyId: office.GLCompanyID,
              countryCode: office.ISOCountryCode,
              phoneTypeId: office.GLPhoneTypeID,
              addressTypeId: office.GLAddressTypeID,
              countryId: office.GLCountryID,
              lastModified: office.LastModified,
              lastModifiedBy: office.LastModifiedBy,
              id: office.EntAgencyID,
              primaryAgencyInd: office.PrimaryAgencyInd,
            };

            this.originals.push(agency);
          }
        }
      }
      this.updateViewed();
      this.waitCircle = false;
    },
    async Search() {
      this.waitCircle = true;

      let fromDate = new Date(this.dateFormatted);
      fromDate.setHours(0, 0, 0, 0);
      let toDate = new Date(this.dateFormatted2);
      toDate.setHours(23, 59, 59, 0);

      let offices = await API.graphql(
        graphqlOperation(queries.getAgencyHistoryByDateRange, {
          rangeStart: fromDate.toISOString(),
          rangeEnd: toDate.toISOString(),
          company: this.$store.state.currentCompany,
        })
      ).catch((e) => {
        this.addToErrorLogs(
          "History.vue getAgencyUpdates getAgencyHistoryByDateRange",
          e
        );
        this.waitCircle = false;
        this.$modal.show("errorModal");
        this.agencies = [];
        return;
      });

      if (!offices.data) {
        this.addToErrorLogs(
          "History.vue getAgencyUpdates getAgencyHistoryByDateRange",
          "No data returned"
        );
        this.waitCircle = false;
        this.$modal.show("errorModal");
        this.agencies = [];
        return;
      }

      this.agencies = [];
      this.originals = [];

      // marker

      for (let office of offices.data.getAgencyHistoryByDateRange) {
        let aoName;
        let AO = this.AOs.data.getAOs.find(
          (a) => a.AgentNumPrimary == office.AOAgentNumPrimary
        );

        if (AO) {
          aoName = (
            (AO.FirstName + " " + AO.MiddleName).trim() +
            " " +
            AO.LastName
          ).trim();
        }

        let agency = {
          AOAgentNumPrimary: office.AOAgentNumPrimary,
          AOName: aoName,
          code: office.AgencyCode,
          name: office.AgencyName,
          address1: office.AddressLine1,
          address2: office.AddressLine2,
          city: office.City,
          state: office.StateProvinceCode,
          zip: office.PostalCode,
          phone:
            (office.AreaCode ? office.AreaCode : "") +
            (office.PhoneNum ? office.PhoneNum : ""),
          phoneExt: office.PhoneExtensionNum,
          country: office.CountryName,
          email: office.Email,
          companyId: office.GLCompanyID,
          countryCode: office.ISOCountryCode,
          phoneTypeId: office.GLPhoneTypeID,
          addressTypeId: office.GLAddressTypeID,
          countryId: office.GLCountryID,
          lastModified: office.LastModified,
          lastModifiedBy: office.LastModifiedBy,
          id: office.EntAgencyID,
          primaryAgencyInd: office.PrimaryAgencyInd,
        };

        if (agency.phone == "0") {
          agency.phone = "";
        }

        this.agencies.push(agency);

        let officeHistory = await API.graphql(
          graphqlOperation(queries.getAgencyHistoryByAgencyCode, {
            agencyCode: office.AgencyCode,
            company: this.$store.state.currentCompany,
          })
        ).catch((e) => {
          this.addToErrorLogs(
            "History.vue getAgencyUpdates getAgencyHistoryByAgencyCode",
            e
          );
          this.waitCircle = false;
          this.$modal.show("errorModal");
          this.agencies = [];
          return;
        });

        if (!officeHistory.data) {
          this.addToErrorLogs(
            "History.vue getAgencyUpdates getAgencyHistoryByAgencyCode",
            "Data not returned"
          );
          this.waitCircle = false;
          this.$modal.show("errorModal");
          this.agencies = [];
          return;
        }

        if (officeHistory.data.getAgencyHistoryByAgencyCode) {
          for (let office of officeHistory.data.getAgencyHistoryByAgencyCode) {
            let agency = {
              AOAgentNumPrimary: office.AOAgentNumPrimary,
              code: office.AgencyCode,
              name: office.AgencyName,
              address1: office.AddressLine1,
              address2: office.AddressLine2,
              city: office.City,
              state: office.StateProvinceCode,
              zip: office.PostalCode,
              phone:
                (office.AreaCode ? office.AreaCode : "") +
                (office.PhoneNum ? office.PhoneNum : ""),
              phoneExt: office.PhoneExtensionNum,
              country: office.CountryName,
              email: office.Email,
              companyId: office.GLCompanyID,
              countryCode: office.ISOCountryCode,
              phoneTypeId: office.GLPhoneTypeID,
              addressTypeId: office.GLAddressTypeID,
              countryId: office.GLCountryID,
              lastModified: office.LastModified,
              lastModifiedBy: office.LastModifiedBy,
              id: office.EntAgencyID,
              primaryAgencyInd: office.PrimaryAgencyInd,
            };
            this.originals.push(agency);
          }
        }
      }

      let dt = this.date;
      dt += "T12:00:00.000Z";
      let dt2 = this.date2;
      dt2 += "T12:00:00.000Z";
      this.filterDate = new Date(dt);
      this.filterDate.setHours(0, 0, 0, 0);
      this.filterDate2 = new Date(dt2);
      this.filterDate2.setHours(this.filterDate2.getHours() + 24);
      this.filterDate2.setHours(0, 0, 0, 0);

      this.waitCircle = false;
    },
    checkDate(check) {
      if (check == null) return false;

      try {
        let checking = new Date(check);
        checking.setHours(0, 0, 0, 0);
        let fromDate = new Date(this.dateFormatted);
        fromDate.setHours(0, 0, 0, 0);
        let toDate = new Date(this.dateFormatted2);
        toDate.setHours(0, 0, 0, 0);

        if (
          checking.getTime() <= toDate.getTime() &&
          checking.getTime() >= fromDate.getTime()
        )
          return true;
      } catch (e) {
        this.addToErrorLogs("History.vue checkDate", e);
      }

      return false;
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
  },
  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
    },
    date2() {
      this.dateFormatted2 = this.formatDate(this.date2);
    },
  },
  mounted() {
    EventBus.$on(
      "addressChangeCancel",
      function () {
        this.editDialog = false;
      }.bind(this)
    );
    EventBus.$on(
      "addressChange",
      function () {
        this.editDialog = false;
        this.$modal.show("savedModal");
      }.bind(this)
    );
  },
  beforeDestroy() {
    EventBus.$off("addressChangeCancel");
    EventBus.$off("addressChange");
  },
  computed: {
    filteredAgencies() {
      return this.agencies.filter((a) => {
        let historyOK = true;
        let origs = this.originals.filter((o) => o.code == a.code);

        if (origs) {
          for (let orig of origs) {
            if (new Date(orig.lastModified) > new Date(a.lastModified))
              historyOK = false;
          }
        }

        return (
          new Date(a.lastModified) >= this.filterDate &&
          new Date(a.lastModified) <= this.filterDate2 &&
          historyOK
        );
      });
    },
    dateProblem() {
      let fromDate = new Date(this.dateFormatted);
      fromDate.setHours(0, 0, 0, 0);
      let toDate = new Date(this.dateFormatted2);
      toDate.setHours(0, 0, 0, 0);

      if (toDate.getTime() < fromDate.getTime()) return true;

      return false;
    },
  },
  data() {
    return {
      AOs: [],
      editItem: null,
      editDialog: false,
      expandedId: 0,
      expanded: [],
      singleSelect: false,
      selected: [],
      isSelected: false,
      waitCircle: false,
      blankFill: "  ",
      filterDate: new Date(),
      filterDate2: new Date(),
      date: new Date(threeDaysAgo).toISOString().substr(0, 10),
      dateFormatted: this.formatDate(threeDaysAgo.toISOString().substr(0, 10)),
      date2: new Date().toISOString().substr(0, 10),
      dateFormatted2: this.formatDate(new Date().toISOString().substr(0, 10)),
      menu1: false,
      menu2: false,
      agencies: [],
      originals: [],
      headers: [
        { text: "AO Number", value: "AOAgentNumPrimary", sortable: true },
        {
          text: "Agency Name",
          align: "start",
          value: "name",
          sortable: true,
        },
        {
          text: "Agency Number",
          align: "start",
          value: "code",
          sortable: true,
        },
        {
          text: "Primary Agency",
          align: "start",
          value: "primaryAgencyInd",
          sortable: false,
        },

        { text: "Address", value: "address1", sortable: false },
        { text: "Address 2", value: "address2", sortable: false },
        { text: "City", value: "city", sortable: false },
        { text: "State / Province", value: "state", sortable: false },
        { text: "Zip/Postal Code", value: "zip", sortable: false },
        { text: "Country", value: "country", sortable: false },
        { text: "Phone", value: "phone", sortable: false },
        { text: "Ext", value: "phoneExt", sortable: false },
        { text: "Email", value: "email", sortable: false },
        { text: "Modified", value: "lastModified", sortable: true },
        { text: "Modified By", value: "lastModifiedBy", sortable: false },
        { text: "Edit", value: "edit", sortable: false },
        {
          text: "",
          value: "data-table-expand",
          align: "center",
          sortable: false,
        },
      ],
    };
  },
};
</script>
<style scoped>
.historyDiv {
  margin-top: 150px;
  margin-left: 20px;
  margin-right: 20px;
}
.historyTitle {
  color: #00558c;
  text-align: center;
  font-weight: bold;
}
.subtitle {
  text-align: center;
}
</style>
<style>
.v-date-picker-table {
  height: 250px;
}
tr .v-data-table__expanded .v-data-table__expanded__row {
  color: #00558c !important;
}
.waitCircleHistory {
  z-index: 50;
  position: absolute;
  top: 60%;
  left: 48%;
}
.expanded {
  justify-content: center !important;
  align-content: center !important;
}
td {
  font-size: 12px !important;
  padding-left: 10px;
}

.v-data-table-header-mobile th {
  padding-left: 30px !important;
}
#expansionHistoryTable > div.v-data-table__wrapper > table > thead {
  display: none;
}

.margin-left-15 {
  margin-left: 15px;
}
/* 
#historyTable > div.v-data-table__wrapper > table > thead > tr {
  background-color: #00558c;
}
#historyTable > div.v-data-table__wrapper > table > thead > tr > th {
  color: white !important;
}
#historyTable > div.v-data-table__wrapper > table > thead > tr > th > i {
  color: white !important;
} */
</style>

